<!-- Right sidebar panel -->
<div class="mdai-panel-backdrop" *ngIf="isPanelOpen && !isFullscreen" (click)="closePanel()"></div>

<div class="mdai-panel"
     data-testid="ai-rail"
     [attr.data-shell]="'assist'"
     [class.open]="isPanelOpen"
     [class.fullscreen]="isFullscreen">

  <!-- Header -->
  <div class="mdai-header">
    <div class="mdai-header-left">
      <i class="bi bi-stars mdai-sparkle-icon"></i>
      <span class="mdai-title">Meal Dynamics AI</span>
    </div>
    <div class="mdai-header-actions">
      <button class="mdai-header-btn" title="New chat" (click)="newChat()">
        <i class="bi bi-pencil-square"></i>
      </button>
      <button class="mdai-header-btn" title="History">
        <i class="bi bi-clock-history"></i>
      </button>
      <button class="mdai-header-btn" title="Toggle fullscreen" (click)="toggleFullscreen()">
        <i [class]="isFullscreen ? 'bi bi-fullscreen-exit' : 'bi bi-arrows-fullscreen'"></i>
      </button>
      <button class="mdai-header-btn" title="Close" (click)="closePanel()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </div>

  <div class="mdai-header-divider"></div>

  <!-- Chat area -->
  <div class="mdai-chat-area" #chatContainer>

    <!-- Welcome state (no messages yet) -->
    <div class="mdai-welcome" *ngIf="chatHistory.length === 0 && !chatLoading">
      <div class="mdai-welcome-greeting">
        Hey {{ userName }}, what would you like to get done?
      </div>

      <div class="mdai-quick-cards">
        <button class="mdai-quick-card" data-testid="ai-quick-prompt" (click)="chatMessage = 'Create AP Requests'; sendMessage()">
          <div class="mdai-quick-card-icon purple"><i class="bi bi-file-earmark-plus"></i></div>
          <div class="mdai-quick-card-text">
            <span class="mdai-quick-card-title">Create AP Requests</span>
            <span class="mdai-quick-card-desc">Add accounts payable by uploading your invoices</span>
          </div>
        </button>
        <button class="mdai-quick-card" data-testid="ai-quick-prompt" (click)="chatMessage = 'Fix Rejected Invoices'; sendMessage()">
          <div class="mdai-quick-card-icon orange"><i class="bi bi-exclamation-triangle"></i></div>
          <div class="mdai-quick-card-text">
            <span class="mdai-quick-card-title">Fix Rejected Invoices</span>
            <span class="mdai-quick-card-desc">Correct and resubmit rejected invoices</span>
          </div>
        </button>
        <button class="mdai-quick-card" data-testid="ai-quick-prompt" (click)="chatMessage = 'Fix Sync Issues'; sendMessage()">
          <div class="mdai-quick-card-icon blue"><i class="bi bi-arrow-repeat"></i></div>
          <div class="mdai-quick-card-text">
            <span class="mdai-quick-card-title">Fix Sync Issues</span>
            <span class="mdai-quick-card-desc">Resolve invoices that failed to sync</span>
          </div>
        </button>
        <button class="mdai-quick-card" data-testid="ai-quick-prompt" (click)="chatMessage = 'Find the Right COA'; sendMessage()">
          <div class="mdai-quick-card-icon green"><i class="bi bi-search"></i></div>
          <div class="mdai-quick-card-text">
            <span class="mdai-quick-card-title">Find the Right COA</span>
            <span class="mdai-quick-card-desc">Get help selecting the right chart of account</span>
          </div>
        </button>
      </div>
    </div>

    <!-- Chat messages -->
    <div class="mdai-messages" *ngIf="chatHistory.length > 0" (click)="onMessagesClick($event)">
      <div *ngFor="let msg of chatHistory; let i = index"
           class="mdai-message"
           [class.user]="msg.role === 'user'"
           [class.assistant]="msg.role === 'assistant'">

        <!-- User message -->
        <div *ngIf="msg.role === 'user'" class="mdai-user-msg-wrap">
          <div class="mdai-user-actions">
            <button class="mdai-msg-action-btn" title="Edit">
              <i class="bi bi-pencil"></i>
            </button>
            <button class="mdai-msg-action-btn" title="Copy" (click)="copyMessage(msg.content)">
              <i class="bi bi-clipboard"></i>
            </button>
          </div>
          <div class="mdai-bubble user-bubble">
            <span>{{ msg.content }}</span>
            <!-- Attached files on user message -->
            <div *ngIf="msg.attachments && msg.attachments.length > 0" class="mdai-msg-attachments">
              <div *ngFor="let att of msg.attachments" class="mdai-file-card sent">
                <div class="mdai-file-icon pdf"><i class="bi bi-file-earmark-pdf-fill"></i></div>
                <div class="mdai-file-info">
                  <span class="mdai-file-name">{{ att.name }}</span>
                  <span class="mdai-file-size">{{ getFileSizeLabel(att.size) }}</span>
                </div>
                <i class="bi bi-check-circle-fill mdai-file-check"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- Assistant message -->
        <div *ngIf="msg.role === 'assistant'" class="mdai-assistant-msg-wrap">
          <div class="mdai-bubble assistant-bubble" [innerHTML]="msg.content | markdown"></div>
        </div>
      </div>

      <!-- Bulk AP progress: step chips + grouped summary. Replaces the per-invoice review
           cards; drafts are reviewed in the AP module. -->
      <app-ai-batch-progress
        *ngFor="let batch of activeBatches; trackBy: trackBatch"
        [batch]="batch"
        (cancelRequested)="onCancelBatch($event)">
      </app-ai-batch-progress>

      <!-- Action progress items -->
      <div *ngIf="actionProgressItems.length > 0" class="mdai-action-progress">
        <div *ngFor="let item of actionProgressItems" class="mdai-progress-item"
             [class.done]="item.status === 'done'"
             [class.error]="item.status === 'error'"
             [class.in-progress]="item.status === 'in_progress'">
          <i *ngIf="item.status === 'pending'" class="bi bi-circle"></i>
          <i *ngIf="item.status === 'in_progress'" class="bi bi-arrow-clockwise spin"></i>
          <i *ngIf="item.status === 'done'" class="bi bi-check-circle-fill text-success"></i>
          <i *ngIf="item.status === 'error'" class="bi bi-x-circle-fill text-danger"></i>
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>

    <!-- Thinking indicator -->
    <div *ngIf="chatLoading" class="mdai-thinking">
      <span>Thinking</span>
      <span class="mdai-dots">
        <span class="dot"></span><span class="dot"></span><span class="dot"></span><span class="dot"></span>
      </span>
    </div>

    <!-- Bulk AP progress. The chips above carry the detail; this is the "still working" line,
         and chat stays usable throughout — the batch runs in the background. -->
    <div *ngIf="activeBatches.length" class="mdai-ocr-progress d-flex align-items-center gap-2 p-2">
      <i class="ri-loader-4-line"></i>
      <span>{{ batchProgressLabel }}</span>
    </div>
  </div>

  <!-- Bottom section -->
  <div class="mdai-bottom">
    <!-- Quick prompt chips -->
    <div class="mdai-chips-row" *ngIf="chatHistory.length > 0">
      <button class="mdai-chip" (click)="chatMessage = 'Why is spend higher this week?'; sendMessage()">Why is spend higher this week?</button>
      <button class="mdai-chip" (click)="chatMessage = 'Which stores are overspending?'; sendMessage()">Which stores are overspending?</button>
      <button class="mdai-chip" (click)="chatMessage = 'How much do we owe right now?'; sendMessage()">How much do we owe right now?</button>
      <button class="mdai-chip" (click)="chatMessage = 'Where are approvals getting stuck?'; sendMessage()">Where are approvals getting stuck?</button>
    </div>

    <!-- Pending attachments -->
    <div *ngIf="pendingAttachments.length > 0" class="mdai-pending-files">
      <div *ngFor="let att of pendingAttachments; let i = index" class="mdai-file-card"
           data-testid="ai-upload-item"
           [attr.data-state]="att.error ? 'failed' : att.uploading ? 'uploading' : 'complete'"
           [class.uploading]="att.uploading" [class.error]="att.error">
        <div class="mdai-file-icon pdf"><i class="bi bi-file-earmark-pdf-fill"></i></div>
        <div class="mdai-file-info">
          <span class="mdai-file-name">{{ att.name }}</span>
          <span class="mdai-file-size">{{ getFileSizeLabel(att.file.size) }}</span>
        </div>
        <span *ngIf="att.uploading" class="mdai-file-spinner"><i class="bi bi-arrow-clockwise spin"></i></span>
        <i *ngIf="!att.uploading && !att.error" class="bi bi-check-circle-fill mdai-file-check"></i>
        <button *ngIf="att.error" class="mdai-file-retry" (click)="retryAttachment(i)" title="Retry">
          <i class="bi bi-arrow-clockwise"></i>
        </button>
        <button class="mdai-file-remove" (click)="removeAttachment(i)" title="Remove">
          <i class="bi bi-x"></i>
        </button>
      </div>
    </div>

    <!-- Attachment error -->
    <div *ngIf="attachmentError" class="mdai-attachment-error">
      <i class="bi bi-exclamation-circle me-1"></i>{{ attachmentError }}
    </div>

    <!-- Input area -->
    <div class="mdai-input-wrap">
      <textarea
        #chatInput
        class="mdai-textarea"
        data-testid="ai-composer"
        [(ngModel)]="chatMessage"
        (keydown)="onInputKeydown($event)"
        (input)="autoGrowTextarea($event)"
        placeholder="Tell MealDynamics AI what to do"
        rows="1"
        [disabled]="chatLoading">
      </textarea>
      <div class="mdai-input-actions">
        <div class="mdai-input-left">
          <button class="mdai-input-btn" (click)="fileInput.click()" title="Attach files">
            <i class="bi bi-paperclip"></i>
          </button>
        </div>
        <div class="mdai-input-right">
          <button *ngIf="speechSupported"
                  class="mdai-input-btn"
                  [class.recording]="isRecording"
                  (click)="toggleVoiceInput()"
                  title="Voice input">
            <i class="bi bi-mic"></i>
          </button>
          <button class="mdai-send-btn" data-testid="ai-send"
                  [disabled]="chatLoading || (!chatMessage.trim() && pendingAttachments.length === 0)"
                  (click)="sendMessage()">
            <i class="bi bi-arrow-up"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Hidden file input -->
    <input #fileInput type="file" multiple hidden data-testid="ai-file-input" (change)="onFilesSelected($event)"
           accept=".pdf,.png,.jpg,.jpeg,.gif,.doc,.docx,.xls,.xlsx,.csv,.txt">

    <!-- Footer disclaimer -->
    <div class="mdai-footer-disclaimer">
      Meal Dynamics AI can make mistakes, So double-check it!
    </div>
  </div>
</div>
